import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-tag-background-color: var(--sds-tag-background-color, var(--sds-color-surface-tinted, var(--sds-color-neutral-surface-tinted)));
		--_sds-tag-text-color: var(--sds-tag-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));

		--_sds-tag-font-family: var(--sds-tag-font-family, var(--sds-typography-font-family-roboto));
		--_sds-tag-font-weight: var(--sds-tag-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-tag-font-size: var(--sds-tag-font-size, var(--sds-components-font-size-content-md));
		--_sds-tag-line-height: var(--sds-tag-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-tag-height: var(--sds-tag-height, var(--sds-components-chip-md));
		--_sds-tag-gap: var(--sds-tag-gap, var(--sds-spacing--zero));
		--_sds-tag-padding-inline: var(--sds-tag-padding-inline, var(--sds-spacing-3xs));
		--_sds-tag-border-radius: var(--sds-tag-border-radius, var(--sds-radius-xs));

		display: inline-block;
		box-sizing: border-box;
	}

	.sds-tag {
		height: var(--_sds-tag-height);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: var(--_sds-tag-gap);
		padding-inline: var(--_sds-tag-padding-inline);

		color: var(--_sds-tag-text-color);
		background-color: var(--_sds-tag-background-color);
		border-radius: var(--_sds-tag-border-radius);

		font-family: var(--_sds-tag-font-family);
		font-size: var(--_sds-tag-font-size);
		font-weight: var(--_sds-tag-font-weight);
		line-height: var(--_sds-tag-line-height);
		text-align: center;

		user-select: text;
	}

	:host([data-palette]) {
		--_sds-tag-background-color: var(--sds-tag-background-color, var(--sds-color-surface-tinted));
		--_sds-tag-text-color: var(--sds-tag-text-color, var(--sds-color-text-default));
	}

	:host([data-palette='danger-action']) {
		--_sds-tag-background-color: var(--sds-tag-background-color, var(--sds-color-alert-danger-action-default));
		--_sds-tag-text-color: var(--sds-tag-text-color, var(--sds-color-alert-danger-action-contrast-default));
	}

	:host([size='sm']) {
		--_sds-tag-height: var(--sds-tag-height, var(--sds-components-chip-sm));
		--_sds-tag-font-size: var(--sds-tag-font-size, var(--sds-components-font-size-content-sm));
		--_sds-tag-line-height: var(--sds-tag-line-height, var(--sds-components-line-height-squeezed-sm));
	}

	:host([size='lg']) {
		--_sds-tag-height: var(--sds-tag-height, var(--sds-components-chip-lg));
		--_sds-tag-font-size: var(--sds-tag-font-size, var(--sds-components-font-size-content-lg));
		--_sds-tag-line-height: var(--sds-tag-line-height, var(--sds-components-line-height-squeezed-lg));
	}
`;
